/**
 * Products Feature Models
 * Barrel export for all product-related interfaces
 */

// Product summary for list views
export * from "./product-summary.interface";

// Product counts for filter sidebar
export * from "./product-counts.interface";

// Filter form controls and values
export * from "./product-filters.interface";

// API request/response types
export * from "./product-api.interface";

// Re-export core product interfaces for convenience
export type {
  QPilotProduct,
  SimpleAndVariationProduct,
} from "../../../core/models/qpilot/product.interface";
export type {
  QPilotProductGroup,
  QPilotProductGroupProduct,
} from "../../../core/models/qpilot/product-group.interface";
